var map = {
	"./basketball.webp": 1652,
	"./bti-img.webp": 1653,
	"./bti-title-cn.webp": 1654,
	"./bti-title-en.webp": 1655,
	"./cup.webp": 1656,
	"./football.webp": 1657,
	"./im-img.webp": 1658,
	"./im-title-cn.webp": 1659,
	"./im-title-en.webp": 1660,
	"./sb-img.webp": 1661,
	"./sb-title-cn.webp": 1662,
	"./sb-title-en.webp": 1663,
	"./sbo-img.webp": 1664,
	"./sbo-title-cn.webp": 1665,
	"./sbo-title-en.webp": 1666,
	"./sport-bg.webp": 1667,
	"./sport-ctg.webp": 1668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 662;